export default __webpack_public_path__ + "ac04fe94596c5a14e2e6f87b220e9525.png";